import React from 'react';
import { formatDate } from '../../utils/formatHelpers';

/**
 * PalletsTable - Table view for displaying pallets
 */
const PalletsTable = ({
  pallets,
  onView,
  onEdit
}) => {
  if (pallets.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">📦</div>
        <p className="empty-text">No pallets found</p>
        <p className="empty-subtext">Create your first pallet to get started</p>
      </div>
    );
  }

  return (
    <div className="pallets-table-container">
      <table className="pallets-table">
        <thead>
          <tr>
            <th>Pallet #</th>
            <th>Customer</th>
            <th>Contents</th>
            <th>Lot #</th>
            <th>Items</th>
            <th>Total Weight</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {pallets.map((pallet) => (
            <tr key={pallet.id}>
              <td className="pallet-number">
                <span className="clickable-link" onClick={() => onView(pallet)}>
                  {pallet.pallet_number}
                </span>
                {pallet.notes && (
                  <span className="pallet-notes-indicator" title={pallet.notes}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2l5 5h-5V4zM6 20V4h5v7h7v9H6z"/>
                      <path d="M8 12h8v2H8zm0 4h5v2H8z"/>
                    </svg>
                  </span>
                )}
                {pallet.label_text && (
                  <span className="pallet-label-badge" style={{ backgroundColor: pallet.label_color || '#757575' }}>
                    {pallet.label_text}
                  </span>
                )}
                {pallet.is_full === 1 && (
                  <span className="pallet-full-badge">FULL</span>
                )}
              </td>
              <td>{pallet.customer_name || '-'}</td>
              <td className="pallet-contents">
                <span className="items-preview">{pallet.item_names || '-'}</span>
              </td>
              <td>{pallet.all_lot_numbers || pallet.lot_number}</td>
              <td>{pallet.item_count} items</td>
              <td>{parseFloat(pallet.total_weight || 0).toFixed(2)} kg</td>
              <td>
                <span className={`status-badge ${pallet.status.replace(/\s+/g, '-')}`}>
                  {pallet.status}
                </span>
              </td>
              <td>{formatDate(pallet.created_at)}</td>
              <td>
                <div style={{display: 'flex', gap: '6px'}}>
                  <button
                    className="action-btn view"
                    onClick={() => onView(pallet)}
                  >
                    View
                  </button>
                  {pallet.status !== 'shipped' && (
                    <button
                      className="action-btn edit"
                      onClick={() => onEdit(pallet)}
                    >
                      Edit
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PalletsTable;
